import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from '@/components/layout';
import {
  HeroSection,
  ResearchAreasSection,
  LatestNewsSection,
  SupportersSection,
} from '@/components/home';

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#research-areas') {
      const el = document.getElementById('research-areas');
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, [location.hash]);

  return (
    <Layout>
      <HeroSection />
      <ResearchAreasSection />
      <LatestNewsSection />
      <SupportersSection />
    </Layout>
  );
};

export default Index;
